<template>
    <Dashboard></Dashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Dashboard = defineAsyncComponent(() =>
    import("../../components/Purchasing/POManagement/Dashboard.vue")
);

export default {
    name: "PO_Management_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { Dashboard, AuthLayout },
};
</script>
